import { Accordion, AccordionDetails, AccordionSummary, Box, Card, Divider, Grid, Typography } from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { useShallow } from "zustand/react/shallow";

import globalStyles from "../../../../../assets/styles/global.module.scss";
import styles from "../../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss";

import { useTemplateLibraryStore } from "../../../../../store/templateLibraryStore";
import { ALLOWED_MEDIA_HEADER_TYPES_CAROUSEL, headerTypeIconMap } from "../../constant";
import Required from "../../../../utility/required";


const CarouselFormMediaHeader = (props: any) => {

    const { handleChangeCardMediaHeader } = props;

    const { createTemplatePayload, whastappTemplateHeaderTypes } = useTemplateLibraryStore(useShallow((state) => ({
        createTemplatePayload: state.createTemplatePayload,
        whastappTemplateHeaderTypes: state.whatsappTemplateHeaderTypes,
    })));

    const isDisabled = Boolean(createTemplatePayload?.whatsapp_template_id);
    const selectedMediaHeaderType = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_header?.whatsapp_template_header_type_name;

    return (
        <Accordion defaultExpanded={true} className={`${styles.accordion}`}>
            
            <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" className={styles.accordion__summary}>
                <Grid container justifyContent={"space-between"} alignItems={"center"}>
                    <span className={styles.accordion__summary__text}>
                        Card Media Header <Required />
                    </span>

                    {selectedMediaHeaderType && ALLOWED_MEDIA_HEADER_TYPES_CAROUSEL?.includes(selectedMediaHeaderType?.toLowerCase()) && (
                        <span className={styles.accordion__summary__value}>
                            {selectedMediaHeaderType}
                        </span>
                    )}
                </Grid>
            </AccordionSummary>

            <Divider sx={{ width: "100%", opacity: "1" }} />

            <AccordionDetails className={styles.accordion__details}>
                <Grid container spacing={1.5}>
                    {whastappTemplateHeaderTypes
                        ?.filter((hTypes: any) => ALLOWED_MEDIA_HEADER_TYPES_CAROUSEL?.includes(hTypes?.whatsapp_template_header_type_name?.toLowerCase()))
                        ?.map((headers: any, ind: number) => {
                            const headerTypeName = headers?.whatsapp_template_header_type_name?.toLowerCase();
                            const isSelected = (selectedMediaHeaderType?.toLowerCase() === headers?.whatsapp_template_header_type_name?.toLowerCase());
                            
                            return (
                                <Grid item key={`card-media-header-${ind}`}>
                                    <Card
                                        onClick={() => !isDisabled ? handleChangeCardMediaHeader(headers) : undefined}
                                        className={`${styles.whatsappTemplateFormHeader__card} ${isSelected ? styles['whatsappTemplateFormHeader__card--selected'] : ''} ${isDisabled ? styles['whatsappTemplateFormHeader__card--disabled'] : ''} ${globalStyles.clickable}`}
                                    >
                                        <Box className={styles.whatsappTemplateFormHeader__card__icon}>
                                            {headerTypeIconMap[headerTypeName as keyof typeof headerTypeIconMap] || null}
                                        </Box>

                                        <Typography variant="caption" className={`${styles.whatsappTemplateFormHeader__card__text} ${isSelected ? styles['whatsappTemplateFormHeader__card__text--selected'] : ''}`}>
                                            {headers?.whatsapp_template_header_type_name}
                                        </Typography>
                                    </Card>
                                </Grid>
                            );
                        })
                    }
                </Grid>
            </AccordionDetails>
        </Accordion>
    )

}

export default CarouselFormMediaHeader;
